import { HeaderLoginButton } from './HeaderLoginButton/HeaderLoginButton'
import styled from 'styled-components'
import React, { Component, createRef, Fragment } from 'react'
import { createPortal } from 'react-dom'
import { MailIcon } from '../../../icons/Mail/MailIcon'
import { getUnreadData } from '../../Email/EmailUtils'
import {
  StyledUnreadMessagesCount
} from '../../../ui/UnreadMessagesCount/StyledUnreadMessagesCount'
import {
  StyledEnvelopeContainer
} from '../../../ui/Envelope/StyledEnvelopeContainer'
import { LoginModal } from './LoginModal/LoginModal'

export class LoggedOffHeaderLogin extends Component {
  constructor (props) {
    super(props)

    this.state = {
      isModalOpen: false,
      loginModalRoot: null,
      modalType: null
    }

    this.loginButtonRef = createRef()
    this.mailRef = createRef()
    this.modalRef = createRef()

    this.closeMenuWhenOutsideClick = this.closeMenuWhenOutsideClick.bind(this)
    this.handleModalVisibility = this.handleModalVisibility.bind(this)
  }

  componentDidMount () {
    document.addEventListener('click', this.closeMenuWhenOutsideClick)
  }

  componentWillUnmount () {
    document.removeEventListener('click', this.closeMenuWhenOutsideClick)
  }

  closeMenuWhenOutsideClick (event) {
    if (!this.modalRef.current || !this.mailRef.current || !this.loginButtonRef.current) {
      return
    }

    if (!this.modalRef.current.contains(event.target) &&
        !this.mailRef.current.contains(event.target) &&
        !this.loginButtonRef.current.contains(event.target)) {
      this.setState({
        isModalOpen: false,
        modalType: null
      })
    }
  }

  handleModalVisibility = (newModalType) => {
    const {
      variant
    } = this.props

    if (variant === 'EcoIdTransition') {
      const {
        modalType: currentModalType
      } = this.state

      if (!currentModalType || currentModalType === newModalType) {
        this.setState(({ isModalOpen }) => ({
          isModalOpen: !isModalOpen,
          modalType: isModalOpen ? null : newModalType
        }))
      } else {
        this.setState(() => ({
          modalType: newModalType
        }))
      }
    } else if (variant === 'EcoIdComplete') {
      this.setState((prevState) => ({
        isModalOpen: !prevState.isModalOpen,
        modalType: null
      }))
    }
  }

  render () {
    const {
      props: {
        inbox,
        ecoIdentity,
        leaderboardHeight,
        rtbLeaderboardHeight,
        loginModalElement,
        headerHeight,
        variant,
        activeDynamicLayout
      },
      state: {
        isModalOpen,
        modalType
      }
    } = this

    const unreadMessagesCount = inbox?.summary?.unread || 0
    const { unreadMessagesCountString, unreadFormatType } = getUnreadData(unreadMessagesCount)
    const shouldShowUnreadCount = inbox?.summary

    return (
      <Fragment>
        <StyledContainer>
          <StyledEnvelopeContainer>
            <MailIcon
              ref={this.mailRef}
              type='medium'
              onClick={() => this.handleModalVisibility('mailIcon')}
            />
            {shouldShowUnreadCount &&
              <StyledUnreadMessagesCount $unreadFormatType={unreadFormatType}>
                {unreadMessagesCountString}
              </StyledUnreadMessagesCount>
            }
          </StyledEnvelopeContainer>
          <StyledHeaderLoginButtonContainer $variant={variant}>
            <HeaderLoginButton
              ecoIdentity={ecoIdentity}
              variant={variant}
              onClick={() => this.handleModalVisibility('loginButton')}
              ref={this.loginButtonRef}
            >
              Přihlásit
            </HeaderLoginButton>
            {variant === 'EcoIdTransition' &&
              <StyledNewLabel>nové</StyledNewLabel>
            }
          </StyledHeaderLoginButtonContainer>
        </StyledContainer>
        {isModalOpen && loginModalElement &&
          createPortal(
            <LoginModal
              ref={this.modalRef}
              ecoIdentity={ecoIdentity}
              leaderboardHeight={leaderboardHeight}
              rtbLeaderboardHeight={rtbLeaderboardHeight}
              headerHeight={headerHeight}
              variant={variant}
              activeDynamicLayout={activeDynamicLayout}
              modalType={modalType}
            />,
            loginModalElement
          )
        }
      </Fragment>
    )
  }
}

const StyledHeaderLoginButtonContainer = styled.div`
  position: ${(props) => props.$variant === 'EcoIdTransition' ? 'relative' : 'initial'};
  padding-right: ${(props) => props.$variant === 'EcoIdTransition' ? '40px' : 0};
`

const StyledNewLabel = styled.label`
  position: absolute;
  color: ${({ theme }) => theme.headerLogin.unreadMessagesCount.backgroundColor};
  text-transform: uppercase;
  font-size: 10px;
  font-weight: bold;
`

const StyledContainer = styled.div`
  flex: 1;
  display: flex;
  justify-content: end;
  align-items: end;
  gap: 20px;
`
